import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { xboxOnboardSiteLocationPrefix } from "../constants";
import { getXboxOnboardData } from "../redux/selectors/xboxOnboardSelectors";

/**
 * Redirects AAA users away from ID@Xbox / pitch / programs pages back to the
 * dashboard. AAA partners do not participate in those programs, so they should
 * never land on these routes.
 *
 * Returns `true` while the current user is an AAA user, so the caller can render
 * `null` to avoid briefly flashing restricted content before the redirect runs.
 */
export const useBlockAaaUser = (): boolean => {
  const history = useHistory();
  const data = useSelector(getXboxOnboardData);
  const isAaaUser = data?.hubType === "aaa";

  useEffect(() => {
    if (isAaaUser) {
      history.replace(`${xboxOnboardSiteLocationPrefix}/dashboard`);
    }
  }, [isAaaUser, history]);

  return isAaaUser;
};
